import { useContext, useMemo } from 'react';
import { EntriesContext } from '../context/EntriesContext';

export default function useEntryFilters() {
  const { entries } = useContext(EntriesContext);
  // Unique users
  const users = useMemo(() => Array.from(new Set(entries.map(e => e.user).filter(Boolean))), [entries]);
  // Unique categories
  const categories = useMemo(() => Array.from(new Set(entries.map(e => typeof e.category === 'object' && e.category !== null ? e.category.name : e.category).filter(Boolean))), [entries]);
  // Unique departments
  const departments = useMemo(() => Array.from(new Set(entries.map(e => e.department).filter(Boolean))), [entries]);
  return { users, categories, departments };
}
